import { render, staticRenderFns } from "./block-notifications.vue?vue&type=template&id=63041476&scoped=true&"
import script from "./block-notifications.vue?vue&type=script&lang=js&"
export * from "./block-notifications.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications.vue?vue&type=style&index=0&id=63041476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63041476",
  null
  
)

export default component.exports